<div class="overview-banner">
    <div class="banner-title">{{ 'BILLING.OVERVIEW' | translate }}</div>
    <div class="stat-cards">
  
      <div class="stat-card">
        <div class="stat-label">
          <img src="assets/images/billing/card.svg" alt="" />
          {{ 'BILLING.OVERALL_BILLING' | translate }}
        </div>
        <div class="stat-value background-green">{{ overallBilling }}</div>
      </div>
  
      <div class="stat-card">
        <div class="stat-label">
          <img src="assets/images/billing/bin.svg" alt="" />
          {{ 'BILLING.CHARGEABLE_UNITS' | translate }}
        </div>
        <div class="stat-value">{{ totalChargeableUnits }} <span class="currency">{{ 'BILLING.CURRENT_CAP' | translate }}</span></div>
      </div>
  
      <div class="stat-card">
        <div class="stat-label">
          <img src="assets/images/billing/plus.svg" alt="" />
          {{ 'BILLING.NEW_INSTALLED_UNITS' | translate }}
        </div>
        <div class="stat-value">{{ newInstalledUnits }}</div>
      </div>
  
    </div>
  </div>
  